<template>
  <div>
    <form>
      <base-card v-if="!targetItem._id">
        <base-tabs :tabs="modeTabs" :tabActived="tabActived" @change="changeMode" />
        <base-message class="gold mt_30">{{ `${StringLanguage.infoAboutCategory[targetItem.mode]}` }}</base-message>
      </base-card>

      <base-card>
        <base-question text="Informe o nome da categoria" class="mb_15"/>
        <base-input v-focus :label="StringLanguage.categoryName" class="mb_0" v-model="targetItem.name" :valid="isValidField('main', 'name')" />
      </base-card>

      <pizza-form
        ref="pizza"
        v-show="targetItem.mode == 'pizza'"
        v-on:updateModel="updatePizzaModel"
        :setDeleteMode="setDeleteMode"
        @onScrollTo="(boxTarget) => $emit('onScrollTo', boxTarget)"
      />
      <drink-form
        ref="drink"
        v-show="targetItem.mode == 'drink'"
        v-on:updateModel="updateDrinkModel"
        :setDeleteMode="setDeleteMode"
        @onScrollTo="(boxTarget) => $emit('onScrollTo', boxTarget)"
      />
      <step-form
        ref="step"
        v-show="targetItem.mode == 'step'"
        v-on:updateModel="updateStepModel"
        :setDeleteMode="setDeleteMode"
        @onScrollTo="(boxTarget) => $emit('onScrollTo', boxTarget)"
      />

    </form>
  </div>
</template>
<script>
import Builder from "easyjs/lib/Schema/Components/Builder";
import Vue from "vue";
import { Money } from "v-money";
import BaseCard from "@/components/Card";
import BaseInput from "@/components/Input";
import BaseTabs from "@/components/Tabs";
import BaseMessage from "@/components/Message";
import BaseQuestion from "@/components/Question";

import PizzaForm from "@/containers/Catalog/Drawers/CategoryForms/Pizza";
import DrinkForm from "@/containers/Catalog/Drawers/CategoryForms/Drink";
import StepForm from "@/containers/Catalog/Drawers/CategoryForms/Step";


import StringTemplate from "easyjs/lib/Tools/StringTemplate";

export default {
  props: {
    setDeleteMode: { type: Function },
    saveCategory: { type: Function }
  },
  data() {
    const targetItem = Builder.factory("Category");
    targetItem.mode = 'pizza';

    return {
      StringTemplate,
      targetItem,
      sameSize: false,
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false
      },
      errors: { main: [] },
      modeTabs: [
        { name: StringLanguage.pizza, value: "pizza" },
        { name: StringLanguage.drinks, value: "drink" },
        { name: StringLanguage.others, value: "step" }
      ],
    };
  },
  components: {
    BaseCard,
    BaseInput,
    BaseTabs,
    BaseMessage,
    BaseQuestion,
    PizzaForm,
    DrinkForm,
    StepForm
  },
  mounted() {
    Vue.directive('focus', (el) => {
        el.querySelector('input[placeholder="Nome da categoria"]').focus()
    })
  },
  computed: {
    tabActived() {
      return ['pizza', 'drink', 'step'].indexOf(this.targetItem.mode);
    }
  },
  methods: {
    updatePizzaModel(model) {
      const newTargetItem = model;
      newTargetItem.name = this.targetItem.name;
      this.targetItem = newTargetItem;
    },
    updateStepModel(model) {
      const newTargetItem = model;
      newTargetItem.name = this.targetItem.name;
      this.targetItem = newTargetItem;
    },
    updateDrinkModel(model) {
      const newTargetItem = model;
      newTargetItem.name = this.targetItem.name;
      this.targetItem = newTargetItem;
    },
    applyValue(_id, key, value) {
      this.targetItem.getItemsByParam("_id", _id).forEach((i) => {
        Vue.set(i, key, value);
      });
    },
    setModel(item, parent) {
      this.errors = { main: [] };

      if(!item) {
        this.targetItem = Builder.factory("Category");
        this.targetItem.mode = 'pizza';
      } else {
        this.targetItem = item;
      }

      this.targetItem.parent = null;
      if(this.targetItem.mode != 'drink' && this.targetItem.sizes.length == 0) {
        let defaultSize = Builder.factory("Size");
        defaultSize._id = Builder.generateRandomId("_");
        defaultSize.name = "Tamanho Único";
        this.targetItem.addItems(defaultSize);
      }

      this.$refs[this.targetItem.mode].setModel(this.targetItem, this.targetItem.parent);
    },
    changeMode(sMode) {

      this.targetItem.mode = sMode;
      if(sMode == 'step') {
        Vue.set(this.targetItem, 'edges', []);
        Vue.set(this.targetItem, 'doughs', []);
      } else if(sMode == 'drink') {
        Vue.set(this.targetItem, 'edges', []);
        Vue.set(this.targetItem, 'doughs', []);
      } else {
        this.updateDoughs();
        this.updateEdges();
        this.updateExtras();
        this.updateItems();
      }

      this.$refs[this.targetItem.mode].setModel(this.targetItem);
    },
    // deleteItem(id = null, showConfirm = true) {
    //   if (id) {
    //     const deleteFn = () => {
    //         this.targetItem.getItemsByParam("_id", id).forEach(i => Vue.set(i, 'delete', true))
    //         //Remove todos os tamanhos que foram excluídos
    //         let catalog = Builder.factory('Catalog');
    //         catalog.addItems(this.targetItem);
    //         Builder.executeOnSchema(catalog, (item) => {
    //           if(item.sizes.length > 0) {
    //             Vue.set(item, 'sizes', item.sizes.filter(s => !s.delete))
    //           }
    //         });
    //     }

    //     if(showConfirm) {
    //       confirm(StringLanguage.confirmDelete, res => res && deleteFn());
    //     } else {
    //       deleteFn();
    //     }

    //   } else {
    //     this.targetItem.delete;
    //     this.$emit("saveItem", this.targetItem);
    //   }
    // },
    getItem() {
      return this.targetItem;
    },
    updateItems() {
      this.targetItem.items.forEach(e => {
        let itemSizes = e.sizes.reduce((obj, size) => ({ ...obj, [size._id]: size }), {});
        e.sizes = this.targetItem.sizes.map(s => {
          return itemSizes[s._id] || Builder.mountSchema(Object.clone(s));
        }).filter(s => !s.delete);
      });
    },
    updateEdges() {
      this.targetItem.edges.forEach(e => {
        let edgeSizes = e.sizes.reduce((obj, size) => ({ ...obj, [size._id]: size }), {});
        e.sizes = this.targetItem.sizes.map(s => {
          return edgeSizes[s._id] || Builder.mountSchema(Object.clone(s));
        }).filter(s => !s.delete);
      });
    },
    updateDoughs() {
      this.targetItem.doughs.forEach(e => {
        let doughSizes = e.sizes.reduce((obj, size) => ({ ...obj, [size._id]: size }), {});
        e.sizes = this.targetItem.sizes.map(s => {
          return doughSizes[s._id] || Builder.mountSchema(Object.clone(s));
        }).filter(s => !s.delete);
      });
    },
    updateExtras() {
      this.targetItem.extra_ingredients.forEach(e => {
        let extraSizes = e.sizes.reduce((obj, size) => ({ ...obj, [size._id]: size }), {});
        e.sizes = this.targetItem.sizes.map(s => {
          return extraSizes[s._id] || Builder.mountSchema(Object.clone(s));
        }).filter(s => !s.delete);
      });
    },
    isValidField(_id, field) {
      return !this.errors[_id] || this.errors[_id].indexOf(field) == -1;
    },
    highlightErrorFields() {
      this.errors = { main: [] };

      if(!this.targetItem.name) {
        this.errors.main = [...(this.errors.main || []), 'name'];
      }

      if(this.$refs[this.targetItem.mode].highlightErrorFields) {
        this.$refs[this.targetItem.mode].highlightErrorFields();
      }
    }
  }
};
</script>
<style scoped>

.text-title {
  text-transform: uppercase;
  color: #868686;
  font-weight: 900;
  font-size: 10px;
  width: 100%;
  text-align: center;
}
.text-title.double:not(.left) {
  text-align: left !important;
  margin-bottom: 5px;
}
.text-title.left {
  text-align: left !important;
  min-width: 120px;
  max-width: 120px;
  padding-left: 10px;
}
.card-header {
  position: relative;
}

.card-header .close-button,
.card-header .open-button {
  cursor: pointer;
  position: absolute;
  top: -4px;
  right: 5px;
}

.card-header span.open-button {
  top: 4px;
}

.select-size {
  background: var(--box-up);
  width: 100%;
  color: var(--label-primary);
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  text-align: center;
  border-radius: 5px;
  border: 1px solid transparent;
  cursor: pointer;
}

.select-size i {
  color: var(--icon-inactive);
  font-size: 1.7em;
}

.select-size:last-child i:nth-child(1) {
  font-size: 1em;
}

.select-size:last-child i:nth-child(2) {
  font-size: 1.3em;
}

.select-size:last-child i:nth-child(3) {
  font-size: 1.6em;
}

.select-size.selected,
.select-size.selected i {
  color: var(--default);
}

.eae-title{
    font-size: 1.4em;
    padding: 16px 0 15px 0;
    text-align: center;
    width: 100%;
    background: #eee;
    margin-bottom: 25px;
    color: #999;
}

</style>
